import React, { Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import PriceList from "./priceList";
const ComparePrice = () => {
  return (
    <Fragment>
      <Breadcrumb title="Compare Product Price" parent="price compare" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Compare Price</h5>
              </CardHeader>
              <CardBody>
                <PriceList />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ComparePrice;
